module.exports = __webpack_public_path__ + "static/media/email.4f884f2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/email.svg
// module id = 199
// module chunks = 0